export default __webpack_public_path__ + "static/media/callisto-logo-on-black.398adc28.png";